<template>
    <section class="content">
        <div class="title-bar">
            <h1>My Courses</h1>
        </div>
        <div class="bg-secondary p-2">
            <p class="m-0 text-align-center text-white">
                See below for a list of your purchased courses that are accessible from this software program.
                For a full list of your purchased courses (in this and any other learning path), please visit
                <strong>mlctraining.com</strong> in your browser and log in.
            </p>
        </div>

        <div class="listable p-3" v-if="courses && courses.length">
            <div class="listable-head">
                <div class="th">
                    <span class="label">Course</span>
                </div>
                <div class="th">
                    <span class="label">Hours</span>
                </div>
                <div class="th">
                    <span class="label">Purchase Date</span>
                </div>
                <div class="th">
                    <span class="label">Status</span>
                </div>
            </div>
            <div
                v-for="course in courses"
                :key="course.id"
                class="listable-data d-not-mobile"
            >
                <div class="td">{{ course.name }}</div>
                <div class="td">{{ course.total_hours }}</div>
                <div class="td">{{ $moment(course.enrollment.enrolled_at).format('MM/DD/YYYY') }}</div>
                <div class="td">{{ course.enrollment.completion_status_label }}</div>
                <div class="td text-right">
                    <ContextMenu :items="menu(course)" align="right" />
                </div>
            </div>
	        <div
		        v-for="course in courses"
		        :key="course.id"
		        class="listable-data"
	        >
		        <div class="d-mobile">
		            <ListCard :item="course" :id="course.id"  />
		        </div>
            </div>
        </div>
        <div
            v-else
            class="alert alert-info text-center mt-3"
        >
            <p class="m-0">No courses found.</p>
        </div>
    </section>
</template>

<script>
import ListCard from "components/partials/Courses/VendorCourseListCard";
import ListingMixin from "mixins/Listing";

export default {
	mixins: [ListingMixin],
	components: {
		ListCard,
	},
    props: {
        courses: { type: Array, default: () => [] }
    },
    methods: {
        menu(course) {
            return [
                {
                    label: "Launch",
                    action: () => {
                        this.goToUrl(course.launch_url);
                    }
                }
            ];
        }
    }
};
</script>

<style scoped>
.d-not-mobile {
	display: table-row;
}
.d-mobile {
	display: none;
}

@media only screen and (max-width: 991px) {
	.d-not-mobile {
		display: none;
	}
	.d-mobile {
		display: block;
	}
}
</style>